import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79f4ead5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "summary__total-price" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary__total-price--header" }, "Total", -1 /* HOISTED */))
const _hoisted_3 = {
  key: 0,
  class: "summary__total-price--fixed"
}

import { storeToRefs } from 'pinia';
import { usePromo } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromoTotalPrices',
  setup(__props) {

const { totalPrice, isDiscounted, getPromoPrice } = storeToRefs(usePromo());

return (_ctx: any,_cache: any) => {
  const _component_AppNumber = _resolveComponent("AppNumber")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", {
      class: _normalizeClass(["summary__total-price--total", { crossed: _unref(isDiscounted) }])
    }, [
      _createTextVNode(" $"),
      _createVNode(_component_AppNumber, {
        input: _unref(totalPrice),
        fixed: 2
      }, null, 8 /* PROPS */, ["input"])
    ], 2 /* CLASS */),
    (_unref(isDiscounted))
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createTextVNode(" $"),
          _createVNode(_component_AppNumber, {
            input: _unref(getPromoPrice),
            fixed: 2
          }, null, 8 /* PROPS */, ["input"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})